import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import PurchaseRequestFields from "./components/PurchaseRequestFields";
import PurRequestItems from "./components/PurRequestItems";
import Footer from "../../../Include/Footer";
import { getDrawing } from "../../../../../Store/Erp/Planner/Draw/Draw";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getParty } from "../../../../../Store/Store/Party/Party";
import { getItem } from "../../../../../Store/Store/Item/Item";
import moment from "moment";
import toast from "react-hot-toast";
import { V_URL } from "../../../../../BaseUrl";
import axios from "axios";
import { getViewPrItems } from "../../../../../Store/prosafe/proTransaction/PurRequest/getViewPrItems";
import { getDepartment } from "../../../../../Store/Admin/believe/PurchaseRequest/department";
import getPaymentList, {
  getStorePayment,
} from "../../../../../Store/Store/StoreMaster/PaymentMethod/getPaymentList";
import { getQuotation } from "../../../../../Store/Store/StoreMaster/Quotation/getQuotationList";

const ManagePurRequest = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    exp_delivery_date: "",
    remarks: "",
    master_id: "",
    project_id: "",
    manual_pro_no: "",
    department_id: null,
    payment_method_id: "",
    quotation_id: ""
  });
  const [drIds, setDrIds] = useState([]);
  const [itemsArr, setItemsArr] = useState([]);

  useEffect(() => {
    dispatch(getDrawing());
    dispatch(getGenMaster({ tag_id: 9 }));
    dispatch(getProject());
    dispatch(getParty({ is_main: true }));
    dispatch(getItem({ is_main: true }));
    dispatch(getQuotation());
  }, []);

  useEffect(() => {
    dispatch(getDepartment());
    dispatch(getStorePayment({ status: "true" }));
  }, [dispatch]);

  const itemData = useSelector((state) => state?.getViewPrItems?.user?.data);
  const getDropdownDepartment = useSelector(
    (state) => state?.getDropdownDepartment?.user?.data
  );

  useEffect(() => {
    if (data?._id) {
      dispatch(getViewPrItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: moment(data?.trans_date).format("YYYY-MM-DD"),
        master_id: data?.prepare_by?._id,
        project_id: data?.project_details?._id,
        manual_pro_no: data?.manual_pro_no,
        exp_delivery_date: data?.exp_delivery_date
          ? moment(data?.exp_delivery_date).format("YYYY-MM-DD")
          : "",
        remarks: data?.remarks,
        department_id: data?.department_id,
        payment_method_id: data?.payment_method_id,
        quotation_id: data?.quotation_details?._id,
      });
      setDrIds(data?.drawing_no?.map((e) => e?._id));
    } else {
      setForm({
        trans_date: moment(Date.now()).format("YYYY-MM-DD"),
        exp_delivery_date: "",
        master_id: "",
        project_id: "",
        manual_pro_no: "",
        remarks: "",
        department_id: null,
        payment_method_id: "",
        quotation_id: "",
      });
      setDrIds([]);
      setItemsArr([]);
      setError({});
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details);
      } else {
        setItemsArr([]);
      }
    } else {
      setItemsArr([]);
    }
  }, [itemData, data]);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Request",
      link: "/main-store/user/purchase-request-management",
    },
    { label: data?._id ? "Edit" : "Add" + " Purchase Request", active: true },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }

    if (!validateItems()) return;
    
    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-add-one-pr`;
    const formData = new URLSearchParams();

    const firm_id = localStorage.getItem("PAY_USER_FIRM_ID");
    const year_id = localStorage.getItem("PAY_USER_YEAR_ID");

    const payload = {
      firm_id,
      year_id,
      tag_number: 9,
      trans_date: form.trans_date,
      exp_delivery_date: form.exp_delivery_date,
      master_id: form.master_id,
      quotation_id: form.quotation_id ? form.quotation_id : null,
      remarks: form.remarks,
      department_id: form.department_id ? form.department_id : null,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,
      payment_method_id: form.payment_method_id,
      drawing_id: JSON.stringify(drIds),
      items_details: JSON.stringify(itemsArr),
    };

    axios({
      method: "post",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-request-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleUpdate = () => {
    if (!validateForm()) {
      return;
    }

    if (!validateItems()) return;


    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-update-pr`;

    const payload = {
      id: data?._id,
      trans_date: form.trans_date,
      exp_delivery_date: form.exp_delivery_date,
      master_id: form.master_id,
      quotation_id: form.quotation_id ? form.quotation_id : null,
      remarks: form.remarks,
      department_id: form.department_id,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,
      payment_method_id: form.payment_method_id,
      drawing_id: JSON.stringify(drIds),
    };

    axios({
      method: "put",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-request-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const validateItems = () => {
    if (!itemsArr || itemsArr.length === 0) {
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }
    if (!form.master_id) {
      newErrors.master_id = "Requested by is required";
      isValid = false;
    }
    if (!form.project_id) {
      newErrors.project_id_err = "Project is required";
      isValid = false;
    }
    if (!form.payment_method_id) {
      newErrors.payment_err = "Payment Method is required";
      isValid = false;
    }
    setError(newErrors);
    return isValid;
  };

  const handleReset = () => {
    setForm({
      trans_date: "",
      exp_delivery_date: "",
      remarks: "",
      master_id: "",
      project_id: "",
      department_id: null,
      payment_method_id: "",
    });
    setDrIds([]);
    setError({});
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>
                          {data?._id ? "Edit" : "Add"} Purchase Request Details
                        </h4>
                      </div>
                    </div>
                    <PurchaseRequestFields
                      form={form}
                      getDepartment={getDropdownDepartment}
                      handleChange={handleChange}
                      error={error}
                      data={data}
                      setDrIds={setDrIds}
                      drIds={drIds}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          <PurRequestItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            drIds={drIds}
            data={data}
          />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={data?._id ? handleUpdate : handleSubmit}
                        disabled={disable && !data?._id}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                          ? "Update"
                          : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ManagePurRequest;
